/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Consul Global Network Manager Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2022-02-15
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { HashicorpCloudGlobalNetworkManager20220215AgentBootstrapResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215AgentDiscoverResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215CreateClusterResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215CreatePeeringConnectionsResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215DeleteClusterResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215GetAggregateServiceSummaryResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215GetClusterAPIInfoResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215GetClusterManagementTokenDetailsResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215GetClusterResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215GetClusterSecretsResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215GetObservabilitySecretResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215GetServiceResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215GetServiceSummariesResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215GetTrialResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215ListClusterPartitionsResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215ListClusterServersResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215ListClusterServicesResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215ListClustersResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215ListClustersWithAcceptorEligibilityResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215ListClustersWithDialerEligibilityResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215ListConsulVersionsResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215ListPeersByClusterPartitionResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215ListServiceInstancesResponseFromJSON, HashicorpCloudGlobalNetworkManager20220215ListServicesResponseFromJSON, InlineObjectToJSON, InlineObject1ToJSON, InlineObject2ToJSON, InlineObject3ToJSON, InlineObject4ToJSON, } from '../models';
/**
 *
 */
export class GlobalNetworkManagerServiceApi extends runtime.BaseAPI {
    /**
     */
    async agentBootstrapConfigRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling agentBootstrapConfig.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling agentBootstrapConfig.');
        }
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling agentBootstrapConfig.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.consulVersion !== undefined) {
            queryParameters['consul_version'] = requestParameters.consulVersion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{id}/agent/bootstrap_config`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215AgentBootstrapResponseFromJSON(jsonValue));
    }
    /**
     */
    async agentBootstrapConfig(locationOrganizationId, locationProjectId, id, locationRegionProvider, locationRegionRegion, consulVersion) {
        const response = await this.agentBootstrapConfigRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, id: id, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion, consulVersion: consulVersion });
        return await response.value();
    }
    /**
     */
    async agentDiscoverRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling agentDiscover.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling agentDiscover.');
        }
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling agentDiscover.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling agentDiscover.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{id}/agent/discover`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject2ToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215AgentDiscoverResponseFromJSON(jsonValue));
    }
    /**
     */
    async agentDiscover(locationOrganizationId, locationProjectId, id, body) {
        const response = await this.agentDiscoverRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, id: id, body: body });
        return await response.value();
    }
    /**
     */
    async agentPushServerStateRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling agentPushServerState.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling agentPushServerState.');
        }
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling agentPushServerState.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling agentPushServerState.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{id}/agent/server-state`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject3ToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async agentPushServerState(locationOrganizationId, locationProjectId, id, body) {
        const response = await this.agentPushServerStateRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, id: id, body: body });
        return await response.value();
    }
    /**
     */
    async createClusterRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling createCluster.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling createCluster.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCluster.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObjectToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215CreateClusterResponseFromJSON(jsonValue));
    }
    /**
     */
    async createCluster(locationOrganizationId, locationProjectId, body) {
        const response = await this.createClusterRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, body: body });
        return await response.value();
    }
    /**
     */
    async createPeeringConnectionsRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling createPeeringConnections.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling createPeeringConnections.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createPeeringConnections.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/peering_connections`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject4ToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215CreatePeeringConnectionsResponseFromJSON(jsonValue));
    }
    /**
     */
    async createPeeringConnections(locationOrganizationId, locationProjectId, body) {
        const response = await this.createPeeringConnectionsRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, body: body });
        return await response.value();
    }
    /**
     */
    async deleteClusterRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling deleteCluster.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling deleteCluster.');
        }
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteCluster.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215DeleteClusterResponseFromJSON(jsonValue));
    }
    /**
     */
    async deleteCluster(locationOrganizationId, locationProjectId, id, locationRegionProvider, locationRegionRegion) {
        const response = await this.deleteClusterRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, id: id, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async deletePeeringConnectionRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling deletePeeringConnection.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling deletePeeringConnection.');
        }
        if (requestParameters.peeringConnectionId === null || requestParameters.peeringConnectionId === undefined) {
            throw new runtime.RequiredError('peeringConnectionId', 'Required parameter requestParameters.peeringConnectionId was null or undefined when calling deletePeeringConnection.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/peering_connections/{peering_connection_id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"peering_connection_id"}}`, encodeURIComponent(String(requestParameters.peeringConnectionId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deletePeeringConnection(locationOrganizationId, locationProjectId, peeringConnectionId, locationRegionProvider, locationRegionRegion) {
        const response = await this.deletePeeringConnectionRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, peeringConnectionId: peeringConnectionId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     * GetAggregateServiceSumamry returns a summary of all the service instances. Callers should use the response\'s AggregateServiceSummaryByKind field that keys service summaries by service kind.
     */
    async getAggregateServiceSummaryRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getAggregateServiceSummary.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getAggregateServiceSummary.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.filterClusters) {
            queryParameters['filter.clusters'] = requestParameters.filterClusters;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/aggregate_service_summary`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215GetAggregateServiceSummaryResponseFromJSON(jsonValue));
    }
    /**
     * GetAggregateServiceSumamry returns a summary of all the service instances. Callers should use the response\'s AggregateServiceSummaryByKind field that keys service summaries by service kind.
     */
    async getAggregateServiceSummary(locationOrganizationId, locationProjectId, locationRegionProvider, locationRegionRegion, filterClusters) {
        const response = await this.getAggregateServiceSummaryRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion, filterClusters: filterClusters });
        return await response.value();
    }
    /**
     */
    async getClusterRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getCluster.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getCluster.');
        }
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getCluster.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215GetClusterResponseFromJSON(jsonValue));
    }
    /**
     */
    async getCluster(locationOrganizationId, locationProjectId, id, locationRegionProvider, locationRegionRegion) {
        const response = await this.getClusterRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, id: id, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getClusterAPIInfoRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getClusterAPIInfo.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getClusterAPIInfo.');
        }
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getClusterAPIInfo.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{id}/api_information`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215GetClusterAPIInfoResponseFromJSON(jsonValue));
    }
    /**
     */
    async getClusterAPIInfo(locationOrganizationId, locationProjectId, id, locationRegionProvider, locationRegionRegion) {
        const response = await this.getClusterAPIInfoRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, id: id, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getClusterManagementTokenDetailsRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getClusterManagementTokenDetails.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getClusterManagementTokenDetails.');
        }
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getClusterManagementTokenDetails.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{id}/management_token_details`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215GetClusterManagementTokenDetailsResponseFromJSON(jsonValue));
    }
    /**
     */
    async getClusterManagementTokenDetails(locationOrganizationId, locationProjectId, id, locationRegionProvider, locationRegionRegion) {
        const response = await this.getClusterManagementTokenDetailsRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, id: id, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getClusterSecretsRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getClusterSecrets.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getClusterSecrets.');
        }
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getClusterSecrets.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{id}/secrets`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215GetClusterSecretsResponseFromJSON(jsonValue));
    }
    /**
     */
    async getClusterSecrets(locationOrganizationId, locationProjectId, id, locationRegionProvider, locationRegionRegion) {
        const response = await this.getClusterSecretsRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, id: id, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getObservabilitySecretRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getObservabilitySecret.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getObservabilitySecret.');
        }
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getObservabilitySecret.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{id}/credentials/observability`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215GetObservabilitySecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async getObservabilitySecret(locationOrganizationId, locationProjectId, id, locationRegionProvider, locationRegionRegion) {
        const response = await this.getObservabilitySecretRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, id: id, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async getServiceRaw(requestParameters) {
        if (requestParameters.clusterResourceName === null || requestParameters.clusterResourceName === undefined) {
            throw new runtime.RequiredError('clusterResourceName', 'Required parameter requestParameters.clusterResourceName was null or undefined when calling getService.');
        }
        if (requestParameters.serviceName === null || requestParameters.serviceName === undefined) {
            throw new runtime.RequiredError('serviceName', 'Required parameter requestParameters.serviceName was null or undefined when calling getService.');
        }
        const queryParameters = {};
        if (requestParameters.partition !== undefined) {
            queryParameters['partition'] = requestParameters.partition;
        }
        if (requestParameters.namespace !== undefined) {
            queryParameters['namespace'] = requestParameters.namespace;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/2022-02-15/global-network-manager/{cluster_resource_name}/service/{service_name}`.replace(`{${"cluster_resource_name"}}`, encodeURIComponent(String(requestParameters.clusterResourceName))).replace(`{${"service_name"}}`, encodeURIComponent(String(requestParameters.serviceName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215GetServiceResponseFromJSON(jsonValue));
    }
    /**
     */
    async getService(clusterResourceName, serviceName, partition, namespace) {
        const response = await this.getServiceRaw({ clusterResourceName: clusterResourceName, serviceName: serviceName, partition: partition, namespace: namespace });
        return await response.value();
    }
    /**
     */
    async getServiceSummariesRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling getServiceSummaries.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling getServiceSummaries.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.filterNameSubstr !== undefined) {
            queryParameters['filter.name_substr'] = requestParameters.filterNameSubstr;
        }
        if (requestParameters.filterClusters) {
            queryParameters['filter.clusters'] = requestParameters.filterClusters;
        }
        if (requestParameters.filterPartitions) {
            queryParameters['filter.partitions'] = requestParameters.filterPartitions;
        }
        if (requestParameters.filterNamespaces) {
            queryParameters['filter.namespaces'] = requestParameters.filterNamespaces;
        }
        if (requestParameters.filterKinds) {
            queryParameters['filter.kinds'] = requestParameters.filterKinds;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/services`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215GetServiceSummariesResponseFromJSON(jsonValue));
    }
    /**
     */
    async getServiceSummaries(locationOrganizationId, locationProjectId, locationRegionProvider, locationRegionRegion, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, filterNameSubstr, filterClusters, filterPartitions, filterNamespaces, filterKinds) {
        const response = await this.getServiceSummariesRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, filterNameSubstr: filterNameSubstr, filterClusters: filterClusters, filterPartitions: filterPartitions, filterNamespaces: filterNamespaces, filterKinds: filterKinds });
        return await response.value();
    }
    /**
     */
    async getTrialRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getTrial.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{organization_id}/trial`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215GetTrialResponseFromJSON(jsonValue));
    }
    /**
     */
    async getTrial(organizationId) {
        const response = await this.getTrialRaw({ organizationId: organizationId });
        return await response.value();
    }
    /**
     * ListClusterPartitions returns the list of consul admin partitions for a given cluster
     */
    async listClusterPartitionsRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling listClusterPartitions.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling listClusterPartitions.');
        }
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling listClusterPartitions.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{id}/partitions`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215ListClusterPartitionsResponseFromJSON(jsonValue));
    }
    /**
     * ListClusterPartitions returns the list of consul admin partitions for a given cluster
     */
    async listClusterPartitions(locationOrganizationId, locationProjectId, id, locationRegionProvider, locationRegionRegion) {
        const response = await this.listClusterPartitionsRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, id: id, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async listClusterServersRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling listClusterServers.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling listClusterServers.');
        }
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling listClusterServers.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{id}/servers`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215ListClusterServersResponseFromJSON(jsonValue));
    }
    /**
     */
    async listClusterServers(locationOrganizationId, locationProjectId, id, locationRegionProvider, locationRegionRegion) {
        const response = await this.listClusterServersRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, id: id, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     */
    async listClusterServicesRaw(requestParameters) {
        if (requestParameters.clusterResourceName === null || requestParameters.clusterResourceName === undefined) {
            throw new runtime.RequiredError('clusterResourceName', 'Required parameter requestParameters.clusterResourceName was null or undefined when calling listClusterServices.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.orderBy) {
            queryParameters['order_by'] = requestParameters.orderBy;
        }
        if (requestParameters.partition !== undefined) {
            queryParameters['partition'] = requestParameters.partition;
        }
        if (requestParameters.namespace !== undefined) {
            queryParameters['namespace'] = requestParameters.namespace;
        }
        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }
        if (requestParameters.kind) {
            queryParameters['kind'] = requestParameters.kind;
        }
        if (requestParameters.inMesh !== undefined) {
            queryParameters['in_mesh'] = requestParameters.inMesh;
        }
        if (requestParameters.mtlsMode) {
            queryParameters['mtls_mode'] = requestParameters.mtlsMode;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.externalSources) {
            queryParameters['external_sources'] = requestParameters.externalSources;
        }
        if (requestParameters.tags) {
            queryParameters['tags'] = requestParameters.tags;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/2022-02-15/global-network-manager/{cluster_resource_name}/services`.replace(`{${"cluster_resource_name"}}`, encodeURIComponent(String(requestParameters.clusterResourceName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215ListClusterServicesResponseFromJSON(jsonValue));
    }
    /**
     */
    async listClusterServices(clusterResourceName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, orderBy, partition, namespace, status, kind, inMesh, mtlsMode, query, externalSources, tags) {
        const response = await this.listClusterServicesRaw({ clusterResourceName: clusterResourceName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, orderBy: orderBy, partition: partition, namespace: namespace, status: status, kind: kind, inMesh: inMesh, mtlsMode: mtlsMode, query: query, externalSources: externalSources, tags: tags });
        return await response.value();
    }
    /**
     */
    async listClustersRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling listClusters.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling listClusters.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215ListClustersResponseFromJSON(jsonValue));
    }
    /**
     */
    async listClusters(locationOrganizationId, locationProjectId, locationRegionProvider, locationRegionRegion, type, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listClustersRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion, type: type, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     * ListClustersWithAcceptorEligibility returns the list of clusters along with whether they are eligible to be the acceptor in a peering connection.
     */
    async listClustersWithAcceptorEligibilityRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling listClustersWithAcceptorEligibility.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling listClustersWithAcceptorEligibility.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters_with_acceptor_eligibility`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215ListClustersWithAcceptorEligibilityResponseFromJSON(jsonValue));
    }
    /**
     * ListClustersWithAcceptorEligibility returns the list of clusters along with whether they are eligible to be the acceptor in a peering connection.
     */
    async listClustersWithAcceptorEligibility(locationOrganizationId, locationProjectId, locationRegionProvider, locationRegionRegion) {
        const response = await this.listClustersWithAcceptorEligibilityRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     * ListClustersWithDialerEligibility returns the list of clusters along with whether they are eligible to be the dialer in a peering connection.
     */
    async listClustersWithDialerEligibilityRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling listClustersWithDialerEligibility.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling listClustersWithDialerEligibility.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.acceptorClusterId !== undefined) {
            queryParameters['acceptor_cluster_id'] = requestParameters.acceptorClusterId;
        }
        if (requestParameters.acceptorClusterPartitionName !== undefined) {
            queryParameters['acceptor_cluster_partition_name'] = requestParameters.acceptorClusterPartitionName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters_with_dialer_eligibility`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215ListClustersWithDialerEligibilityResponseFromJSON(jsonValue));
    }
    /**
     * ListClustersWithDialerEligibility returns the list of clusters along with whether they are eligible to be the dialer in a peering connection.
     */
    async listClustersWithDialerEligibility(locationOrganizationId, locationProjectId, locationRegionProvider, locationRegionRegion, acceptorClusterId, acceptorClusterPartitionName) {
        const response = await this.listClustersWithDialerEligibilityRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion, acceptorClusterId: acceptorClusterId, acceptorClusterPartitionName: acceptorClusterPartitionName });
        return await response.value();
    }
    /**
     */
    async listConsulVersionsRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/list_consul_versions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215ListConsulVersionsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listConsulVersions() {
        const response = await this.listConsulVersionsRaw();
        return await response.value();
    }
    /**
     * ListPeersByClusterPartition returns the list of cluster partitions, each containing their respective lists of cluster peers. If a cluster_id is supplied, this endpoint returns the list of cluster partitions only for the specified cluster.
     */
    async listPeersByClusterPartitionRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling listPeersByClusterPartition.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling listPeersByClusterPartition.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.clusterId !== undefined) {
            queryParameters['cluster_id'] = requestParameters.clusterId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/peers_by_cluster_partition`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215ListPeersByClusterPartitionResponseFromJSON(jsonValue));
    }
    /**
     * ListPeersByClusterPartition returns the list of cluster partitions, each containing their respective lists of cluster peers. If a cluster_id is supplied, this endpoint returns the list of cluster partitions only for the specified cluster.
     */
    async listPeersByClusterPartition(locationOrganizationId, locationProjectId, locationRegionProvider, locationRegionRegion, clusterId) {
        const response = await this.listPeersByClusterPartitionRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion, clusterId: clusterId });
        return await response.value();
    }
    /**
     */
    async listServiceInstancesRaw(requestParameters) {
        if (requestParameters.clusterResourceName === null || requestParameters.clusterResourceName === undefined) {
            throw new runtime.RequiredError('clusterResourceName', 'Required parameter requestParameters.clusterResourceName was null or undefined when calling listServiceInstances.');
        }
        if (requestParameters.serviceName === null || requestParameters.serviceName === undefined) {
            throw new runtime.RequiredError('serviceName', 'Required parameter requestParameters.serviceName was null or undefined when calling listServiceInstances.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.namespace !== undefined) {
            queryParameters['namespace'] = requestParameters.namespace;
        }
        if (requestParameters.partition !== undefined) {
            queryParameters['partition'] = requestParameters.partition;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }
        if (requestParameters.orderBy) {
            queryParameters['order_by'] = requestParameters.orderBy;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/2022-02-15/global-network-manager/{cluster_resource_name}/service/{service_name}/instances`.replace(`{${"cluster_resource_name"}}`, encodeURIComponent(String(requestParameters.clusterResourceName))).replace(`{${"service_name"}}`, encodeURIComponent(String(requestParameters.serviceName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215ListServiceInstancesResponseFromJSON(jsonValue));
    }
    /**
     */
    async listServiceInstances(clusterResourceName, serviceName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, namespace, partition, query, status, orderBy) {
        const response = await this.listServiceInstancesRaw({ clusterResourceName: clusterResourceName, serviceName: serviceName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, namespace: namespace, partition: partition, query: query, status: status, orderBy: orderBy });
        return await response.value();
    }
    /**
     * ListServices returns a list of services for all clusters within an HCP project
     */
    async listServicesRaw(requestParameters) {
        if (requestParameters.projectResourceName === null || requestParameters.projectResourceName === undefined) {
            throw new runtime.RequiredError('projectResourceName', 'Required parameter requestParameters.projectResourceName was null or undefined when calling listServices.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.orderBy) {
            queryParameters['order_by'] = requestParameters.orderBy;
        }
        if (requestParameters.partition !== undefined) {
            queryParameters['partition'] = requestParameters.partition;
        }
        if (requestParameters.namespace !== undefined) {
            queryParameters['namespace'] = requestParameters.namespace;
        }
        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }
        if (requestParameters.kind) {
            queryParameters['kind'] = requestParameters.kind;
        }
        if (requestParameters.inMesh !== undefined) {
            queryParameters['in_mesh'] = requestParameters.inMesh;
        }
        if (requestParameters.mtlsMode) {
            queryParameters['mtls_mode'] = requestParameters.mtlsMode;
        }
        if (requestParameters.clusterIds) {
            queryParameters['cluster_ids'] = requestParameters.clusterIds;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.externalSources) {
            queryParameters['external_sources'] = requestParameters.externalSources;
        }
        if (requestParameters.tags) {
            queryParameters['tags'] = requestParameters.tags;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/2022-02-15/global-network-manager/{project_resource_name}/services`.replace(`{${"project_resource_name"}}`, encodeURIComponent(String(requestParameters.projectResourceName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudGlobalNetworkManager20220215ListServicesResponseFromJSON(jsonValue));
    }
    /**
     * ListServices returns a list of services for all clusters within an HCP project
     */
    async listServices(projectResourceName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, orderBy, partition, namespace, status, kind, inMesh, mtlsMode, clusterIds, query, externalSources, tags) {
        const response = await this.listServicesRaw({ projectResourceName: projectResourceName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, orderBy: orderBy, partition: partition, namespace: namespace, status: status, kind: kind, inMesh: inMesh, mtlsMode: mtlsMode, clusterIds: clusterIds, query: query, externalSources: externalSources, tags: tags });
        return await response.value();
    }
    /**
     */
    async updateClusterRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling updateCluster.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling updateCluster.');
        }
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling updateCluster.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateCluster.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/global-network-manager/2022-02-15/organizations/{location.organization_id}/projects/{location.project_id}/clusters/{id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject1ToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updateCluster(locationOrganizationId, locationProjectId, id, body) {
        const response = await this.updateClusterRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, id: id, body: body });
        return await response.value();
    }
}
/**
    * @export
    * @enum {string}
    */
export var GetServiceSummariesFilterKindsEnum;
(function (GetServiceSummariesFilterKindsEnum) {
    GetServiceSummariesFilterKindsEnum["UNSPECIFIED"] = "KIND_UNSPECIFIED";
    GetServiceSummariesFilterKindsEnum["TYPICAL"] = "KIND_TYPICAL";
    GetServiceSummariesFilterKindsEnum["CONNECTPROXY"] = "KIND_CONNECT_PROXY";
    GetServiceSummariesFilterKindsEnum["MESHGATEWAY"] = "KIND_MESH_GATEWAY";
    GetServiceSummariesFilterKindsEnum["TERMINATINGGATEWAY"] = "KIND_TERMINATING_GATEWAY";
    GetServiceSummariesFilterKindsEnum["INGRESSGATEWAY"] = "KIND_INGRESS_GATEWAY";
    GetServiceSummariesFilterKindsEnum["DESTINATION"] = "KIND_DESTINATION";
    GetServiceSummariesFilterKindsEnum["APIGATEWAY"] = "KIND_API_GATEWAY";
})(GetServiceSummariesFilterKindsEnum || (GetServiceSummariesFilterKindsEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var ListClustersTypeEnum;
(function (ListClustersTypeEnum) {
    ListClustersTypeEnum["UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    ListClustersTypeEnum["ALL"] = "TYPE_ALL";
    ListClustersTypeEnum["SELF"] = "TYPE_SELF";
    ListClustersTypeEnum["HCP"] = "TYPE_HCP";
})(ListClustersTypeEnum || (ListClustersTypeEnum = {}));
